import { Component, Input, OnChanges } from '@angular/core';
import { environment } from '@env/environment';
import {
    AuthenticationService,
    DocumentGed,
    EspaceDocumentaireService,
} from '@kv-common-components/kx-services';
import { CommonDossierComponent } from '@kv-common-components/kv-common-components';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-espace-doc-list-desktop',
    templateUrl: 'espace-doc-list-desktop.component.html',
})
export class EspaceDocListDesktopComponent
    extends CommonDossierComponent
    implements OnChanges
{
    @Input() allEspaceDoc;
    @Input() currentPage;
    filterDoc: DocumentGed[];

    constructor(
        private authenticationService: AuthenticationService,
        protected espaceDocumentaireService: EspaceDocumentaireService,
        protected logger: NGXLogger
    ) {
        super(logger, espaceDocumentaireService);
        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnChanges() {
        this.filterDocByTypologie(
            this.currentPage,
            this.allEspaceDoc,
            environment.contractualDocument,
            environment.infoDocument
        );
    }
}
